<footer class="footer-area">
    <h5>
        <p>
            Copyright &copy; TICS Acin - CWK {{ currentYear }}. Todos los
            derechos reservados.
        </p>
        <p
            style="text-align: center">Versión: {{ version }}
        </p>
    </h5>
</footer>
